import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { getGtmData, getDataLayer } from '@/utils/gtm';
import { STAGE } from '@/core/config';

export const useMarketingData = () => {
  const [cookies, setCookie] = useCookies(['mktgData']);

  useEffect(() => {
    const onGtmEvent = () => {
      const dataLayer = getDataLayer();
      // checking STAGE to be able to test on staging by manipulating cookies directly
      if (!dataLayer || STAGE !== 'prd') return;

      const mktgData = getGtmData(dataLayer);
      const currentCookieData = cookies.mktgData;

      if (JSON.stringify(mktgData) !== JSON.stringify(currentCookieData)) {
        setCookie('mktgData', JSON.stringify(mktgData));
      }
    };

    // Polling every 500ms to check when GTM initializes (if it's not available immediately) up to 3 seconds (6 times)
    let numberOfTimesCheckDataLayer = 0;
    const interval = setInterval(() => {
      numberOfTimesCheckDataLayer += 1;
      if (numberOfTimesCheckDataLayer >= 6) {
        clearInterval(interval);
        if (getDataLayer()) {
          onGtmEvent();
        }
      }
    }, 500);

    // Attach event listener to detect new GTM pushes
    const dataLayer = getDataLayer();
    if (dataLayer) {
      const originalPush = dataLayer.push;
      dataLayer.push = function (...args: any[]) {
        originalPush.apply(this, args);
        args.forEach(onGtmEvent);
        return dataLayer.length;
      };
    }

    return () => {
      clearInterval(interval);
      if (dataLayer) dataLayer.push = Array.prototype.push; // Restore original push method
    };
  }, [cookies.mktgData, setCookie]);
};
